/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as React from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import downloadIcon from "assets/images/external-link.png";
import { Button } from "@mui/material";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples

// Images
import innerCover from "assets/images/banners/banner-iqac.webp";
import Container from "@mui/material/Container";

// Material Kit 2 React examples

function NaacReports() {
  const [criteriaDatas, setCriteriaDatas] = React.useState([]);

  const navigate = useNavigate();

  React.useEffect(() => {
    const Arr = [
      { value: "Action-Taken-Reports", name: "Action Taken Reports" },
      { value: "Mentoring-Extension-FDP-Reports", name: "Mentoring,Extension,FDP Reports" },
      { value: "Seminars-or-Workshops", name: "Seminars/Workshops" },
      { value: "Audit-Reports", name: "Audit Reports" },
      { value: "Annual-Reports", name: "Annual Reports" },
    ];
    setCriteriaDatas(Arr);
  }, []);

  return (
    <>
      <MKBox
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${innerCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
        className="innerCover"
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              NAAC Reports
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: { xs: 4, lg: 8 },
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={3} alignItems="center">
            {criteriaDatas.map((typeData) => (
              <Grid item xs={12} lg={4} md={6}>
                <div className="card naac-card">
                  <Button
                    onClick={() => {
                      navigate(`/iqac/pdf-reports?category=${typeData.value}`);
                    }}
                  >
                    <MKBox display="flex" alignItems="center" p={1}>
                      <MKBox
                        variant="gradient"
                        bgColor="warning"
                        color="white"
                        coloredShadow="warning"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="xl"
                        sx={{ p: 0.5 }}
                      >
                        <HistoryEduIcon />
                      </MKBox>

                      <MKTypography
                        pl={2}
                        variant="h5"
                        sx={({ breakpoints, typography: { size } }) => ({
                          [breakpoints.down("md")]: {
                            fontSize: size["2xl"],
                          },
                        })}
                      >
                        {typeData.name}
                      </MKTypography>
                      <Grid item={1} ml={2}>
                        <img
                          src={downloadIcon}
                          className="img-fluid"
                          alt="Download"
                          width="32"
                          height="32"
                        />
                      </Grid>
                    </MKBox>
                    {/* <Grid container spacing={2} alignItems="center" justifyContent="center">
                      
                    </Grid> */}
                  </Button>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Card>
    </>
  );
}

export default NaacReports;
